import { useState } from "react";

import classes from "./HomePage.module.css";

import NoticeBoardLarge from "../../components/General_Elements/NoticeBoardLarge/NoticeBoardLarge";
import NoticeBoardSmall from "../../components/General_Elements/NoticeBoardSmall/NoticeBoardSmall";
import LoadingSpinner from "../../UI/LoadingSpinner";

const HomePage = () => {
  const width = window.innerWidth;
  const [isLoading, setIsLoading] = useState(true);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  return (
    <div
      className={classes.HomePage}
    >
      {isLoading && <LoadingSpinner asOverlay />}

      {width <= 1050 && true && <NoticeBoardSmall />}
      <img
        className={classes.innerImage}
        src={"/assets/gen_graphics/bar_area_image_v2.svg"}
        alt="new"
        onLoad={handleImageLoad}
      />

      {width > 1050 && <NoticeBoardLarge />}
    </div>
  );
};

export default HomePage;
